module.exports = __webpack_public_path__ + "img/troca.261816dd.svg";